import PropTypes from "prop-types";
import React, { useState } from "react";
import AdditionalDetailsLongTextDialog from "./AdditionalDetailsLongTextDialog";
import { formatValue } from "./formatValue";
import HelpTip from "./HelpTip";

const AdditionalDetailsReadRows = ({ definitions, values }) => {
  const [expandedId, setExpandedId] = useState(null);
  const byId = new Map(
    values.map((row) => [String(row.definition_id), row.value]),
  );
  const expanded = definitions.find(
    (field) =>
      field.field_type === "long_text" && String(field.id) === expandedId,
  );
  if (!definitions.length) {
    return null;
  }
  return (
    <>
      <table
        className="table table-flush table-sm no-border"
        style={{ tableLayout: "fixed", overflowWrap: "anywhere" }}
      >
        <tbody>
          {definitions.map((field) => {
            const value = byId.get(String(field.id));
            const longText =
              field.field_type === "long_text" &&
              typeof value === "string" &&
              value.length > 0;
            return (
              <tr key={field.id}>
                <th scope="row" width="40%" className="text-grey-dark">
                  {field.label}:
                  {field.help_text && (
                    <HelpTip label={field.label}>{field.help_text}</HelpTip>
                  )}
                </th>
                <td width="60%" className="text-black">
                  <div
                    style={
                      longText
                        ? {
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            whiteSpace: "pre-wrap",
                          }
                        : undefined
                    }
                  >
                    {formatValue(field, value)}
                  </div>
                  {longText && (
                    <button
                      type="button"
                      className="btn btn-link text-blue shadow-none border-0 p-0"
                      aria-label={`View full text for ${field.label}`}
                      onClick={() => setExpandedId(String(field.id))}
                    >
                      View full text
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {expanded && (
        <AdditionalDetailsLongTextDialog
          label={expanded.label}
          value={String(byId.get(String(expanded.id)) ?? "")}
          onClose={() => setExpandedId(null)}
        />
      )}
    </>
  );
};

AdditionalDetailsReadRows.propTypes = {
  definitions: PropTypes.array.isRequired,
  values: PropTypes.array.isRequired,
};
export default AdditionalDetailsReadRows;
